<template>
  <section class="asc-mxrec-recommendation-details--container">
    <asc-rich-text-input
      :key="getRecommendationText"
      :class="[
        'asc-mxrec-recommendation-details',
        !editable ? 'asc-mxrec-recommendation-details--disabled' : '',
      ]"
      :comment="getRecommendationText"
      :can-edit="editable"
      :max-length="max"
      :counter="editable"
      :reset="reset"
      hidden-menu
      @updated="handleUpdatedText"
    >
    </asc-rich-text-input>
    <template v-if="!fields.valid && editable">
      <asc-validation-message
        class="asc-mxrec-recommendation-details--validation"
        message="This field is required for submission"
        :show="!fields.valid && editable"
      ></asc-validation-message>
    </template>
  </section>
</template>

<script>
import AscRichTextInput from '@/components/atoms/AscRichTextInput'
import AscValidationMessage from '@/components/atoms/AscValidationMessage'
import {
  AscMxRecPropsMixin,
  AscMxRecPermissionMixin,
} from '@/components/mixins'
import { COLLINS_PHM_TIER_3 } from '@/utilities/appConsts'

export default {
  name: 'AscMxRecRecommendationDetailsWrapper',

  components: {
    AscRichTextInput,
    AscValidationMessage,
  },
  mixins: [AscMxRecPropsMixin, AscMxRecPermissionMixin],
  props: {
    fields: {
      type: Object,
      default: () => {},
    },
    max: {
      type: Number,
      default: 0,
    },

    isRecommendationTab: {
      type: Boolean,
      default: false,
    },
    emptyComment: {
      type: String,
      default: '<p></p>',
    },
    reset: {
      type: Boolean,
      default: false,
    },
    airlineTierTypeId: {
      type: Number,
      default: null,
    },
    lockEnabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      recommendationText: '',
    }
  },

  computed: {
    editable() {
      return (
        this.isEditPermissionInvestigate &&
        !this.isRecommendationTab &&
        this.airlineTierTypeId !== COLLINS_PHM_TIER_3 &&
        !this.lockEnabled
      )
    },
    getRecommendationText() {
      return this.recommendationText
    },
  },

  watch: {
    fields: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (this.recommendationText !== newValue.mxRecDetails) {
          this.recommendationText = newValue?.mxRecDetails
        }
      },
    },
  },

  methods: {
    handleUpdatedText(text) {
      const comment = {
        mxRecDetails: text,
        valid: text.replace(/\s/g, '') !== this.emptyComment,
      }
      this.$emit('input', comment)
    },
  },
}
</script>

<style lang="scss">
.asc-mxrec-recommendation-details {
  &--container {
    .asc-textarea-input--container .theme--light.v-input.v-textarea textarea {
      line-height: 32px;
    }
  }

  &--disabled {
    cursor: not-allowed;
  }

  &--validation {
    padding: 3px;
  }
}
</style>
